import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { sortBy } from "lodash";
import { Input } from "formsy-react-components";
import DropdownSearch from "../common/DropdownSearch";

const DepartmentFormRow = ({
  inputs,
  isSubDepartment,
  services,
  tasks,
  onChange
}) => (
  <Row>
    <Col md={2} xs={12}>
      <Input
        required
        name="description"
        formNoValidate
        label="Description"
        value={inputs?.description}
        disabled
      />
    </Col>
    <Col md={2} xs={12}>
      <Input
        required
        name="code"
        formNoValidate
        label="Code"
        value={inputs?.code}
        disabled
      />
    </Col>
    <Col md={2} xs={12}>
      <Input
        name="call_center_code"
        formNoValidate
        required
        label="Call Center Code"
        value={inputs?.call_center_code}
        onChange={(e) => onChange("call_center_code", e.target.value)}
      />
    </Col>
    {!isSubDepartment ? (
      <React.Fragment>
        <Col md={3} xs={12}>
          <DropdownSearch
            name="default_service"
            label="Default Service"
            onChange={(name, value) => onChange(name, value)}
            value={
              inputs?.default_service?._id || inputs?.default_service || ""
            }
            data={[
              ...sortBy(
                services?.map((service) => ({
                  value: service._id,
                  label: service.description
                })),
                [(option) => option?.label?.toLowerCase()]
              )
            ]}
            isClearable
          />
        </Col>
        <Col md={3} xs={12}>
          <DropdownSearch
            disabled={
              !(inputs?.default_service?._id || inputs?.default_service)
            }
            name="default_task"
            label="Default Task"
            onChange={(name, value) => onChange(name, value)}
            value={inputs?.default_task?._id || inputs?.default_task || ""}
            data={[
              ...sortBy(
                tasks?.map((task) => ({
                  value: task._id,
                  label: task?.task?.description
                })),
                [(option) => option?.label?.toLowerCase()]
              )
            ]}
            isClearable
          />
        </Col>
      </React.Fragment>
    ) : null}
  </Row>
);

DepartmentFormRow.propTypes = {
  inputs: PropTypes.object.isRequired,
  isSubDepartment: PropTypes.bool,
  services: PropTypes.array,
  tasks: PropTypes.array,
  onChange: PropTypes.func
};

DepartmentFormRow.defaultProps = {
  isSubDepartment: false,
  onChange: () => {}
};

export default DepartmentFormRow;
